import { arrayOf, string } from 'prop-types';
import React from 'react';

import Titled from '../../layout/Titled';
import { agreementShape } from '../../prop-types';
import api from '../../REST/api';
import AuthorizedLink from '../../REST/AuthorizedLink';
import withResolved from '../../REST/with-resolved';
import AgreementsTable from '../AgreementsTable';

const ListAgreements = ({ agreements, title, titleSize, ...rest }) => (
  <Titled
    title={title}
    size={titleSize}
    actions={
      <AuthorizedLink
        to="/agreements/add"
        className="btn btn-secondary"
        query={api.addAgreement}
      >
        Create Agreement
      </AuthorizedLink>
    }
  >
    <AgreementsTable agreements={agreements} {...rest} />
  </Titled>
);

ListAgreements.propTypes = {
  agreements: arrayOf(agreementShape).isRequired,
  titleSize: string,
  title: string,
};

ListAgreements.defaultProps = {
  titleSize: undefined,
  title: 'Agreements',
};

export default withResolved({
  query: api.getAgreements,
  as: 'agreements',
  deriveQueryArgs: ({ brandIds, relevantFor, relevantForSalesTeam }) => ({
    search: { brandIds, relevantFor, relevantForSalesTeam },
  }),
})(ListAgreements);
